import { Card } from './Card'
import { PieChart, Pie, Tooltip, Label, ResponsiveContainer } from 'recharts'

export const GenderDiversity = ({ data, isLoading, filter, onSubmitFilter }) => {
    return (
        <Card
            isLoading={isLoading}
            title='Gender Diversity'
            filterTitle='Filter Gender Diversity'
            initFilter={filter}
            onSubmitFilter={onSubmitFilter}
        >
            <div className='relative'>
                <ResponsiveContainer height={180}>
                    <PieChart>
                        <Pie data={data?.detail} dataKey='count' nameKey='gender' innerRadius={35} outerRadius={60}>
                            <Label
                                content={({ viewBox }) => {
                                    const { cx, cy } = viewBox
                                    return (
                                        <text x={cx} y={cy} textAnchor='middle' dominantBaseline='middle'>
                                            <tspan x={cx} dy='-5' fontSize='18' fontWeight='bold'>
                                                {data?.total}
                                            </tspan>
                                            <tspan x={cx} dy='16' fontSize='10' fill='#94a3b8'>
                                                TOTAL
                                            </tspan>
                                        </text>
                                    )
                                }}
                            />
                        </Pie>
                        <Tooltip />
                    </PieChart>
                </ResponsiveContainer>
            </div>

            <div className='space-y-4'>
                {data?.detail?.map((item, index) => (
                    <div key={index} className='flex items-center justify-between'>
                        <div className='flex w-9/12 items-center gap-3'>
                            <span className={`w-3 h-3 rounded-full ${item.color}`} />
                            <span className='capitalize text-neutral-80'>{item.gender}</span>
                        </div>

                        <div className='flex w-3/12 items-center justify-between gap-1'>
                            <span className='text-neutral-80'>{item.count}</span>
                            <span className='text-neutral-50'>{item.percentage}%</span>
                        </div>
                    </div>
                ))}
            </div>
        </Card>
    )
}
